import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useBlog from "../commons/hooks/useBlog";
import NewsCard from "../components/landing/NewsCard";
import SectionHeader from "../components/landing/SectionHeader";
import "../components/landing/landing.css";
import "../styles/mobile-carousel.css";

const BlogStack = () => {
	const { blogs, retrieveBlogs } = useBlog({});
	const navigate = useNavigate();

	useEffect(() => {
		retrieveBlogs(3);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	// Mantiene el ancla #blogs mientras cargan (o si no hay) noticias
	if (!blogs[0]) return <section id="blogs" />;

	return (
		<section id="blogs" className="ld-news">
			<div className="ld-container">
				<div className="ld-news-head">
					<SectionHeader eyebrow="Sala de prensa" title="Lo último" />
					<a
						className="ld-news-all"
						href="/blogs"
						onClick={(e) => {
							e.preventDefault();
							navigate("/blogs");
						}}
					>
						Ver todas las noticias →
					</a>
				</div>

				<div className="ld-news-grid mobile-carousel">
					{blogs.slice(0, 3).map((blog) => (
						<NewsCard key={blog.id} blog={blog} />
					))}
				</div>
			</div>
		</section>
	);
};

export default BlogStack;
